import { Gate, PlayerState, AttributeKey } from '../data/types';

/**
 * 通用条件闸门求值器（第 45 批）：全站「按状态筛选」的唯一出口，类型定义见 data/types.ts Gate。
 * AND 语义：全部闸门通过才成立；gates 不写/空数组 = 无条件通过。
 * 首个消费者是 EventSystem.rollRandomEvent；商店/剧本池/固定事件将来逐处收口。
 */
export function gatesPass(gates: Gate[] | undefined, p: PlayerState): boolean {
    if (!gates || gates.length === 0) return true;
    return gates.every(g => {
        let v: number;
        switch (g.type) {
            case 'rank': v = p.rank; break;
            case 'attr': v = p.attributes[g.key as AttributeKey] ?? 0; break;
            case 'money': v = p.resources.money; break;
            case 'energy': v = p.resources.energy; break;
            case 'age': v = p.age; break;
            case 'flag': v = p.flags[g.key ?? ''] ? 1 : 0; break;
            default: return true;   // 未知类型不误杀
        }
        return (g.min === undefined || v >= g.min) && (g.max === undefined || v <= g.max);
    });
}
